/* eslint-disable */
// DO NOT EDIT — this file is auto-generated
// Data model: cdf_cdm/CogniteCore v1

import { ViewMapperCache } from "../mappers/view-mapper";

const VIEW_DUMPS = [
  {
    "externalId": "CogniteDescribable",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "all",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      }
    ],
    "description": "The describable core concept is used as a standard way of holding the bare minimum of information about the instance\n",
    "implements": []
  },
  {
    "externalId": "CogniteSourceable",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "all",
    "isGlobal": true,
    "properties": {
      "sourceId": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceId",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Identifier from the source system"
      },
      "sourceContext": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceContext",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set."
      },
      "source": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "source",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a source system"
      },
      "sourceCreatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was created in source system (if available)"
      },
      "sourceUpdatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was last updated in the source system (if available)"
      },
      "sourceCreatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "sourceUpdatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable"
      }
    ],
    "implements": []
  },
  {
    "externalId": "CogniteSourceSystem",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "version": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceSystem"
        },
        "containerPropertyIdentifier": "version",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Version identifier for the source system"
      },
      "manufacturer": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceSystem"
        },
        "containerPropertyIdentifier": "manufacturer",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Manufacturer of the source system"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceSystem"
      }
    ],
    "description": "The CogniteSourceSystem core concept is used to standardize the way source system is stored.",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteSchedulable",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "startTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSchedulable"
        },
        "containerPropertyIdentifier": "startTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The actual start time of an activity (or similar that extends this)"
      },
      "endTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSchedulable"
        },
        "containerPropertyIdentifier": "endTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The actual end time of an activity (or similar that extends this)"
      },
      "scheduledStartTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSchedulable"
        },
        "containerPropertyIdentifier": "scheduledStartTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The planned start time of an activity (or similar that extends this)"
      },
      "scheduledEndTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSchedulable"
        },
        "containerPropertyIdentifier": "scheduledEndTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The planned end time of an activity (or similar that extends this)"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteSchedulable"
      }
    ],
    "description": "CogniteSchedulable represents the metadata about when an activity (or similar) starts and ends.",
    "implements": []
  },
  {
    "externalId": "CogniteVisualizable",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "object3D": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "Cognite3DObject",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteVisualizable"
        },
        "containerPropertyIdentifier": "object3D",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to an Object3D instance representing the 3D resource"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteVisualizable"
      }
    ],
    "description": "CogniteVisualizable defines the standard way to reference a related 3D resource",
    "implements": []
  },
  {
    "externalId": "Cognite3DTransformation",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1726823088691,
    "writable": true,
    "queryable": true,
    "usedFor": "all",
    "isGlobal": true,
    "properties": {
      "translationX": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "translationX",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The displacement of the object along the X-axis in the 3D coordinate system"
      },
      "translationY": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "translationY",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The displacement of the object along the Y-axis in the 3D coordinate system"
      },
      "translationZ": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "translationZ",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The displacement of the object along the Z-axis in the 3D coordinate system"
      },
      "eulerRotationX": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "eulerRotationX",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The rotation of the object around the X-axis in radians"
      },
      "eulerRotationY": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "eulerRotationY",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The rotation of the object around the Y-axis in radians"
      },
      "eulerRotationZ": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "eulerRotationZ",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The rotation of the object around the Z-axis in radians"
      },
      "scaleX": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "scaleX",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The scaling factor applied to the object along the X-axis"
      },
      "scaleY": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "scaleY",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The scaling factor applied to the object along the Y-axis"
      },
      "scaleZ": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "scaleZ",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The scaling factor applied to the object along the Z-axis"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "Cognite3DTransformation"
      }
    ],
    "description": "The Cognite3DTransformation object defines a comprehensive 3D transformation, enabling precise adjustments to an object's position, orientation, and size in the 3D coordinate system. It allows for the translation of objects along the three spatial axes, rotation around these axes using Euler angles, and scaling along each axis to modify the object's dimensions. The object's transformation is defined in \"CDF space\", a coordinate system where the positive Z axis is the up direction\n",
    "implements": []
  },
  {
    "externalId": "CogniteCubeMap",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "front": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCubeMap"
        },
        "containerPropertyIdentifier": "front",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a file holding the front projection of the cube map"
      },
      "back": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCubeMap"
        },
        "containerPropertyIdentifier": "back",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a file holding the back projection of the cube map"
      },
      "left": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCubeMap"
        },
        "containerPropertyIdentifier": "left",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a file holding the left projection of the cube map"
      },
      "right": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCubeMap"
        },
        "containerPropertyIdentifier": "right",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a file holding the right projection of the cube map"
      },
      "top": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCubeMap"
        },
        "containerPropertyIdentifier": "top",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a file holding the top projection of the cube map"
      },
      "bottom": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCubeMap"
        },
        "containerPropertyIdentifier": "bottom",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a file holding the bottom projection of the cube map"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "CogniteCubeMap"
      }
    ],
    "description": "The cube map holds references to 6 images in used to visually represent the surrounding environment\n",
    "implements": []
  },
  {
    "externalId": "Cognite3DObject",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "xMin": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DObject"
        },
        "containerPropertyIdentifier": "xMin",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Lowest X value in bounding box"
      },
      "xMax": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DObject"
        },
        "containerPropertyIdentifier": "xMax",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Highest X value in bounding box"
      },
      "yMin": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DObject"
        },
        "containerPropertyIdentifier": "yMin",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Lowest Y value in bounding box"
      },
      "yMax": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DObject"
        },
        "containerPropertyIdentifier": "yMax",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Highest Y value in bounding box"
      },
      "zMin": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DObject"
        },
        "containerPropertyIdentifier": "zMin",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Lowest Z value in bounding box"
      },
      "zMax": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DObject"
        },
        "containerPropertyIdentifier": "zMax",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Highest Z value in bounding box"
      },
      "asset": {
        "connectionType": "single_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "CogniteAsset",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteAsset",
            "version": "v1"
          },
          "identifier": "object3D"
        },
        "targetsList": false,
        "description": "Asset that is tied to this 3D object"
      },
      "cadNodes": {
        "connectionType": "multi_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "CogniteCADNode",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteCADNode",
            "version": "v1"
          },
          "identifier": "object3D"
        },
        "targetsList": false,
        "description": "List of up to 1000 CADNodes that represents the connected CogniteAsset"
      },
      "images360": {
        "type": {
          "space": "cdf_cdm",
          "externalId": "image-360-annotation"
        },
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "Cognite360Image",
          "version": "v1"
        },
        "connectionType": "multi_edge_connection",
        "description": "Edge connection to Cognite360Image annotations that represents the connected CogniteAsset",
        "edgeSource": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "Cognite360ImageAnnotation",
          "version": "v1"
        },
        "direction": "outwards"
      },
      "pointCloudVolumes": {
        "connectionType": "multi_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "CognitePointCloudVolume",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CognitePointCloudVolume",
            "version": "v1"
          },
          "identifier": "object3D"
        },
        "targetsList": false,
        "description": "List of up to 1000 PointCloudVolumes that represents the connected CogniteAsset"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "Cognite3DObject"
      }
    ],
    "description": "This is the virtual position representation of an object in the physical world, connecting an asset to one or more 3D resources",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "Cognite3DModel",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1725535663258,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "thumbnail": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DModel"
        },
        "containerPropertyIdentifier": "thumbnail",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Thumbnail of the 3D model"
      },
      "type": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "CAD": {
              "name": "CAD"
            },
            "PointCloud": {
              "name": "PointCloud"
            },
            "Image360": {
              "name": "Image360"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DModel"
        },
        "containerPropertyIdentifier": "type",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "CAD, PointCloud or Image360"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "Cognite3DModel"
      }
    ],
    "description": "Groups revisions of 3D data of various kinds together (CAD, PointCloud, Image360)",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteCADModel",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "thumbnail": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DModel"
        },
        "containerPropertyIdentifier": "thumbnail",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Thumbnail of the 3D model"
      },
      "type": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "CAD": {
              "name": "CAD"
            },
            "PointCloud": {
              "name": "PointCloud"
            },
            "Image360": {
              "name": "Image360"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DModel"
        },
        "containerPropertyIdentifier": "type",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "CAD, PointCloud or Image360"
      },
      "revisions": {
        "connectionType": "multi_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "CogniteCADRevision",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "Cognite3DRevision",
            "version": "v1"
          },
          "identifier": "model3D"
        },
        "targetsList": false,
        "description": "List of revisions for this CAD model"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "Cognite3DModel"
      }
    ],
    "description": "Navigational aid for traversing CogniteCADModel instances",
    "filter": {
      "and": [
        {
          "hasData": [
            {
              "type": "container",
              "space": "cdf_cdm_3d",
              "externalId": "Cognite3DModel"
            }
          ]
        },
        {
          "equals": {
            "property": [
              "cdf_cdm_3d",
              "Cognite3DModel",
              "type"
            ],
            "value": "CAD"
          }
        }
      ]
    },
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "Cognite3DModel",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "Cognite3DRevision",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "status": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "Queued": {
              "name": "Queued"
            },
            "Processing": {
              "name": "Processing"
            },
            "Done": {
              "name": "Done"
            },
            "Failed": {
              "name": "Failed"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "status",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false
      },
      "published": {
        "constraintState": {},
        "type": {
          "type": "boolean",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "published",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false
      },
      "type": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "CAD": {
              "name": "CAD"
            },
            "PointCloud": {
              "name": "PointCloud"
            },
            "Image360": {
              "name": "Image360"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "type",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false
      },
      "model3D": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm_3d",
            "externalId": "Cognite3DModel"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "Cognite3DModel",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "model3D",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "Cognite3DRevision"
      }
    ],
    "description": "Shared revision information for various 3D data types. Normally not used directly, but through CognitePointCloudRevision, Image360Collection or CogniteCADRevision\n",
    "implements": []
  },
  {
    "externalId": "CognitePointCloudModel",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "thumbnail": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DModel"
        },
        "containerPropertyIdentifier": "thumbnail",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Thumbnail of the 3D model"
      },
      "type": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "CAD": {
              "name": "CAD"
            },
            "PointCloud": {
              "name": "PointCloud"
            },
            "Image360": {
              "name": "Image360"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DModel"
        },
        "containerPropertyIdentifier": "type",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "CAD, PointCloud or Image360"
      },
      "revisions": {
        "connectionType": "multi_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "CognitePointCloudRevision",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "Cognite3DRevision",
            "version": "v1"
          },
          "identifier": "model3D"
        },
        "targetsList": false,
        "description": "List of revisions for this PointCloud model"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "Cognite3DModel"
      }
    ],
    "description": "Navigational aid for traversing CognitePointCloudModel instances",
    "filter": {
      "and": [
        {
          "hasData": [
            {
              "type": "container",
              "space": "cdf_cdm_3d",
              "externalId": "Cognite3DModel"
            }
          ]
        },
        {
          "equals": {
            "property": [
              "cdf_cdm_3d",
              "Cognite3DModel",
              "type"
            ],
            "value": "PointCloud"
          }
        }
      ]
    },
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "Cognite3DModel",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "Cognite360ImageModel",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1725535663258,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "thumbnail": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DModel"
        },
        "containerPropertyIdentifier": "thumbnail",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Thumbnail of the 3D model"
      },
      "type": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "CAD": {
              "name": "CAD"
            },
            "PointCloud": {
              "name": "PointCloud"
            },
            "Image360": {
              "name": "Image360"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DModel"
        },
        "containerPropertyIdentifier": "type",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "CAD, PointCloud or Image360"
      },
      "collections": {
        "connectionType": "multi_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "Cognite360ImageCollection",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "Cognite3DRevision",
            "version": "v1"
          },
          "identifier": "model3D"
        },
        "targetsList": false,
        "description": "List Cognite360Image collections for this instance"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "Cognite3DModel"
      }
    ],
    "description": "Navigational aid for traversing Cognite360ImageModel instances",
    "filter": {
      "and": [
        {
          "hasData": [
            {
              "type": "container",
              "space": "cdf_cdm_3d",
              "externalId": "Cognite3DModel"
            }
          ]
        },
        {
          "equals": {
            "property": [
              "cdf_cdm_3d",
              "Cognite3DModel",
              "type"
            ],
            "value": "Image360"
          }
        }
      ]
    },
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "Cognite3DModel",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteCADRevision",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "status": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "Queued": {
              "name": "Queued"
            },
            "Processing": {
              "name": "Processing"
            },
            "Done": {
              "name": "Done"
            },
            "Failed": {
              "name": "Failed"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "status",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false
      },
      "published": {
        "constraintState": {},
        "type": {
          "type": "boolean",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "published",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false
      },
      "type": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "CAD": {
              "name": "CAD"
            },
            "PointCloud": {
              "name": "PointCloud"
            },
            "Image360": {
              "name": "Image360"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "type",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false
      },
      "model3D": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm_3d",
            "externalId": "Cognite3DModel"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteCADModel",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "model3D",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "."
      },
      "revisionId": {
        "constraintState": {},
        "type": {
          "type": "int64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCADRevision"
        },
        "containerPropertyIdentifier": "revisionId",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The 3D API revision identifier for this CAD model"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "Cognite3DRevision"
      },
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "CogniteCADRevision"
      }
    ],
    "description": "",
    "filter": {
      "and": [
        {
          "hasData": [
            {
              "type": "container",
              "space": "cdf_cdm_3d",
              "externalId": "Cognite3DRevision"
            }
          ]
        },
        {
          "equals": {
            "property": [
              "cdf_cdm_3d",
              "Cognite3DModel",
              "type"
            ],
            "value": "CAD"
          }
        }
      ]
    },
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "Cognite3DRevision",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CognitePointCloudRevision",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "status": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "Queued": {
              "name": "Queued"
            },
            "Processing": {
              "name": "Processing"
            },
            "Done": {
              "name": "Done"
            },
            "Failed": {
              "name": "Failed"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "status",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false
      },
      "published": {
        "constraintState": {},
        "type": {
          "type": "boolean",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "published",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false
      },
      "type": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "CAD": {
              "name": "CAD"
            },
            "PointCloud": {
              "name": "PointCloud"
            },
            "Image360": {
              "name": "Image360"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "type",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false
      },
      "model3D": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm_3d",
            "externalId": "Cognite3DModel"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CognitePointCloudModel",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "model3D",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "."
      },
      "revisionId": {
        "constraintState": {},
        "type": {
          "type": "int64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CognitePointCloudRevision"
        },
        "containerPropertyIdentifier": "revisionId",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The 3D API revision identifier for this PointCloud model"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "Cognite3DRevision"
      },
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "CognitePointCloudRevision"
      }
    ],
    "description": "Navigational aid for traversing CognitePointCloudRevision instances",
    "filter": {
      "and": [
        {
          "hasData": [
            {
              "type": "container",
              "space": "cdf_cdm_3d",
              "externalId": "Cognite3DRevision"
            }
          ]
        },
        {
          "equals": {
            "property": [
              "cdf_cdm_3d",
              "Cognite3DModel",
              "type"
            ],
            "value": "PointCloud"
          }
        }
      ]
    },
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "Cognite3DRevision",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "Cognite360ImageCollection",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1725535663258,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "status": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "Queued": {
              "name": "Queued"
            },
            "Processing": {
              "name": "Processing"
            },
            "Done": {
              "name": "Done"
            },
            "Failed": {
              "name": "Failed"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "status",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false
      },
      "published": {
        "constraintState": {},
        "type": {
          "type": "boolean",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "published",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false
      },
      "type": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "CAD": {
              "name": "CAD"
            },
            "PointCloud": {
              "name": "PointCloud"
            },
            "Image360": {
              "name": "Image360"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "type",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false
      },
      "model3D": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm_3d",
            "externalId": "Cognite3DModel"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "Cognite360ImageModel",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DRevision"
        },
        "containerPropertyIdentifier": "model3D",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": ""
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "Cognite3DRevision"
      }
    ],
    "description": "Represents a logical collection of Cognite360Image instances",
    "filter": {
      "and": [
        {
          "hasData": [
            {
              "type": "container",
              "space": "cdf_cdm_3d",
              "externalId": "Cognite3DRevision"
            }
          ]
        },
        {
          "equals": {
            "property": [
              "cdf_cdm_3d",
              "Cognite3DModel",
              "type"
            ],
            "value": "Image360"
          }
        }
      ]
    },
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "Cognite3DRevision",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteCADNode",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "object3D": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm_3d",
            "externalId": "Cognite3DObject"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "Cognite3DObject",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCADNode"
        },
        "containerPropertyIdentifier": "object3D",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to object3D grouping for this node"
      },
      "model3D": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm_3d",
            "externalId": "Cognite3DModel"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteCADModel",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCADNode"
        },
        "containerPropertyIdentifier": "model3D",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to Cognite3DModel"
      },
      "cadNodeReference": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCADNode"
        },
        "containerPropertyIdentifier": "cadNodeReference",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Reference to a node within a CAD model from the 3D API"
      },
      "revisions": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm_3d",
            "externalId": "Cognite3DRevision"
          },
          "list": true,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteCADRevision",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCADNode"
        },
        "containerPropertyIdentifier": "revisions",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "List of direct relations to instances of Cognite3DRevision which this CogniteCADNode exists in."
      },
      "treeIndexes": {
        "constraintState": {},
        "type": {
          "type": "int64",
          "list": true
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCADNode"
        },
        "containerPropertyIdentifier": "treeIndexes",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "List of tree indexes in the same order as revisions. Used by Reveal and similar applications to map from CogniteCADNode to tree index\n"
      },
      "subTreeSizes": {
        "constraintState": {},
        "type": {
          "type": "int64",
          "list": true
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCADNode"
        },
        "containerPropertyIdentifier": "subTreeSizes",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "List of subtree sizes in the same order as revisions. Used by Reveal and similar applications to know how many nodes exists below this node in the hierarchy\n"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "CogniteCADNode"
      }
    ],
    "description": "Represents nodes from the 3D model that have been contextualized",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CognitePointCloudVolume",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "object3D": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm_3d",
            "externalId": "Cognite3DObject"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "Cognite3DObject",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CognitePointCloudVolume"
        },
        "containerPropertyIdentifier": "object3D",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to object3D grouping for this node"
      },
      "model3D": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm_3d",
            "externalId": "Cognite3DModel"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteCADModel",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CognitePointCloudVolume"
        },
        "containerPropertyIdentifier": "model3D",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to Cognite3DModel instance"
      },
      "volumeReferences": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CognitePointCloudVolume"
        },
        "containerPropertyIdentifier": "volumeReferences",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Unique volume metric hashes used to access the 3D specialized data storage"
      },
      "revisions": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm_3d",
            "externalId": "Cognite3DRevision"
          },
          "list": true,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteCADRevision",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CognitePointCloudVolume"
        },
        "containerPropertyIdentifier": "revisions",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "List of direct relations to revision information"
      },
      "volumeType": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "Cylinder": {
              "name": "Cylinder"
            },
            "Box": {
              "name": "Box"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CognitePointCloudVolume"
        },
        "containerPropertyIdentifier": "volumeType",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Type of volume (Cylinder or Box)"
      },
      "volume": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": true
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CognitePointCloudVolume"
        },
        "containerPropertyIdentifier": "volume",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Relevant coordinates for the volume type, 9 floats in total, that defines the volume"
      },
      "formatVersion": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CognitePointCloudVolume"
        },
        "containerPropertyIdentifier": "formatVersion",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Specifies the version the ‘volume’ field is following. Volume definition is today 9 floats (property volume)\n"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "CognitePointCloudVolume"
      }
    ],
    "description": "PointCloud volume definition",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "Cognite360Image",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "translationX": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "translationX",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The displacement of the object along the X-axis in the 3D coordinate system"
      },
      "translationY": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "translationY",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The displacement of the object along the Y-axis in the 3D coordinate system"
      },
      "translationZ": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "translationZ",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The displacement of the object along the Z-axis in the 3D coordinate system"
      },
      "eulerRotationX": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "eulerRotationX",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The rotation of the object around the X-axis in radians"
      },
      "eulerRotationY": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "eulerRotationY",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The rotation of the object around the Y-axis in radians"
      },
      "eulerRotationZ": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "eulerRotationZ",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The rotation of the object around the Z-axis in radians"
      },
      "scaleX": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "scaleX",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The scaling factor applied to the object along the X-axis"
      },
      "scaleY": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "scaleY",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The scaling factor applied to the object along the Y-axis"
      },
      "scaleZ": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DTransformation"
        },
        "containerPropertyIdentifier": "scaleZ",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The scaling factor applied to the object along the Z-axis"
      },
      "front": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCubeMap"
        },
        "containerPropertyIdentifier": "front",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a file holding the front projection of the cube map"
      },
      "back": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCubeMap"
        },
        "containerPropertyIdentifier": "back",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a file holding the back projection of the cube map"
      },
      "left": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCubeMap"
        },
        "containerPropertyIdentifier": "left",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a file holding the left projection of the cube map"
      },
      "right": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCubeMap"
        },
        "containerPropertyIdentifier": "right",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a file holding the right projection of the cube map"
      },
      "top": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCubeMap"
        },
        "containerPropertyIdentifier": "top",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a file holding the top projection of the cube map"
      },
      "bottom": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteFile"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "CogniteCubeMap"
        },
        "containerPropertyIdentifier": "bottom",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a file holding the bottom projection of the cube map"
      },
      "collection360": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm_3d",
            "externalId": "Cognite3DRevision"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "Cognite360ImageCollection",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite360Image"
        },
        "containerPropertyIdentifier": "collection360",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to Cognite360ImageCollection"
      },
      "station360": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm_3d",
            "externalId": "Cognite3DGroup"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "Cognite360ImageStation",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite360Image"
        },
        "containerPropertyIdentifier": "group3d",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to Cognite3DGroup instance that groups different Cognite360Image instances to the same station"
      },
      "takenAt": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite360Image"
        },
        "containerPropertyIdentifier": "takenAt",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The timestamp when the 6 photos were taken"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "Cognite3DTransformation"
      },
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "CogniteCubeMap"
      },
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "Cognite360Image"
      }
    ],
    "description": "",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "Cognite3DTransformation",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteCubeMap",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "Cognite360ImageStation",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "groupType": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "Station360": {
              "name": "Station360"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite3DGroup"
        },
        "containerPropertyIdentifier": "groupType",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Type of group"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "Cognite3DGroup"
      }
    ],
    "description": "A way to group images across collections. Used for creating visual scan history",
    "filter": {
      "and": [
        {
          "hasData": [
            {
              "type": "container",
              "space": "cdf_cdm_3d",
              "externalId": "Cognite3DGroup"
            }
          ]
        },
        {
          "equals": {
            "property": [
              "cdf_cdm_3d",
              "Cognite3DGroup",
              "groupType"
            ],
            "value": "Station360"
          }
        }
      ]
    },
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "Cognite360ImageAnnotation",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "edge",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "sourceId": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceId",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Identifier from the source system"
      },
      "sourceContext": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceContext",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set."
      },
      "source": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "source",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a source system"
      },
      "sourceCreatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was created in source system (if available)"
      },
      "sourceUpdatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was last updated in the source system (if available)"
      },
      "sourceCreatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "sourceUpdatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "confidence": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAnnotation"
        },
        "containerPropertyIdentifier": "confidence",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The confidence that the annotation is a good match"
      },
      "status": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "Suggested": {
              "name": "Suggested"
            },
            "Approved": {
              "name": "Approved"
            },
            "Rejected": {
              "name": "Rejected"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAnnotation"
        },
        "containerPropertyIdentifier": "status",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The status of the annotation"
      },
      "polygon": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": true
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite360ImageAnnotation"
        },
        "containerPropertyIdentifier": "polygon",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "List of floats representing the polygon. Format depends on formatVersion"
      },
      "formatVersion": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm_3d",
          "externalId": "Cognite360ImageAnnotation"
        },
        "containerPropertyIdentifier": "formatVersion",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Specifies the storage representation for the polygon"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteAnnotation"
      },
      {
        "type": "container",
        "space": "cdf_cdm_3d",
        "externalId": "Cognite360ImageAnnotation"
      }
    ],
    "description": "",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteAnnotation",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteAsset",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1726823088691,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "object3D": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "Cognite3DObject",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteVisualizable"
        },
        "containerPropertyIdentifier": "object3D",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to an Object3D instance representing the 3D resource"
      },
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "sourceId": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceId",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Identifier from the source system"
      },
      "sourceContext": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceContext",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set."
      },
      "source": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "source",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a source system"
      },
      "sourceCreatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was created in source system (if available)"
      },
      "sourceUpdatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was last updated in the source system (if available)"
      },
      "sourceCreatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "sourceUpdatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "parent": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteAsset",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAsset"
        },
        "containerPropertyIdentifier": "assetHierarchy_parent",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The parent of the asset.",
        "name": "Parent"
      },
      "root": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteAsset",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAsset"
        },
        "containerPropertyIdentifier": "assetHierarchy_root",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "An automatically updated reference to the top-level asset of the hierarchy.",
        "name": "Root"
      },
      "path": {
        "constraintState": {
          "maxListSize": "current"
        },
        "type": {
          "type": "direct",
          "list": true,
          "maxListSize": 100,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteAsset",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAsset"
        },
        "containerPropertyIdentifier": "assetHierarchy_path",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "An automatically updated ordered list of this asset's ancestors, starting with the root asset. Enables subtree filtering to find all assets under a parent.",
        "name": "Path"
      },
      "pathLastUpdatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAsset"
        },
        "containerPropertyIdentifier": "assetHierarchy_path_last_updated_time",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The last time the path was updated for this asset.",
        "name": "Path last updated time"
      },
      "assetClass": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteAssetClass"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteAssetClass",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAsset"
        },
        "containerPropertyIdentifier": "assetClass",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Specifies the class of the asset. It's a direct relation to CogniteAssetClass.",
        "name": "Asset class"
      },
      "type": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteAssetType"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteAssetType",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAsset"
        },
        "containerPropertyIdentifier": "type",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Specifies the type of the asset. It's a direct relation to CogniteAssetType.",
        "name": "Asset type"
      },
      "files": {
        "connectionType": "multi_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "CogniteFile",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          },
          "identifier": "assets"
        },
        "targetsList": true,
        "name": "Files",
        "description": "An automatically updated list of files related to the asset."
      },
      "children": {
        "connectionType": "multi_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "CogniteAsset",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteAsset",
            "version": "v1"
          },
          "identifier": "parent"
        },
        "targetsList": false,
        "name": "Children",
        "description": "An automatically updated list of assets with this asset as their parent."
      },
      "equipment": {
        "connectionType": "multi_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "CogniteEquipment",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteEquipment",
            "version": "v1"
          },
          "identifier": "asset"
        },
        "targetsList": false,
        "name": "Equipment",
        "description": "An automatically updated list of equipment related to the asset."
      },
      "activities": {
        "connectionType": "multi_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "CogniteActivity",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteActivity",
            "version": "v1"
          },
          "identifier": "assets"
        },
        "targetsList": true,
        "name": "Activities",
        "description": "An automatically updated list of activities related to the asset."
      },
      "timeSeries": {
        "connectionType": "multi_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "CogniteTimeSeries",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteTimeSeries",
            "version": "v1"
          },
          "identifier": "assets"
        },
        "targetsList": true,
        "name": "Time series",
        "description": "An automatically updated list of time series related to the asset."
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteVisualizable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteAsset"
      }
    ],
    "name": "Asset",
    "description": "Assets represent systems that support industrial functions or processes. Assets are often called 'functional location'.",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteVisualizable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteAssetClass",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1726823088691,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "code": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAssetClass"
        },
        "containerPropertyIdentifier": "code",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "A unique identifier for the class of asset.",
        "name": "Code"
      },
      "standard": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAssetClass"
        },
        "containerPropertyIdentifier": "standard",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "A text string to specify which standard the class is from.",
        "name": "Standard"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteAssetClass"
      }
    ],
    "name": "Asset class",
    "description": "Represents the class of an asset.",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteAssetType",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1726823088691,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "code": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAssetType"
        },
        "containerPropertyIdentifier": "code",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "A unique identifier for the type of asset.",
        "name": "Code"
      },
      "standard": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAssetType"
        },
        "containerPropertyIdentifier": "standard",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "A text string to specify which standard the type is from.",
        "name": "Standard"
      },
      "assetClass": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteAssetClass"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteAssetClass",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAssetType"
        },
        "containerPropertyIdentifier": "assetClass",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Specifies the class the type belongs to. It's a direct relation to CogniteAssetClass.",
        "name": "Asset class"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteAssetType"
      }
    ],
    "name": "Asset type",
    "description": "Represents the type of an asset.",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteEquipment",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1726823088691,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "sourceId": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceId",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Identifier from the source system"
      },
      "sourceContext": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceContext",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set."
      },
      "source": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "source",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a source system"
      },
      "sourceCreatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was created in source system (if available)"
      },
      "sourceUpdatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was last updated in the source system (if available)"
      },
      "sourceCreatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "sourceUpdatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "asset": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteAsset",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteEquipment"
        },
        "containerPropertyIdentifier": "asset",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The asset the equipment is related to.",
        "name": "Asset"
      },
      "serialNumber": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteEquipment"
        },
        "containerPropertyIdentifier": "serialNumber",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The serial number of the equipment.",
        "name": "Serial number"
      },
      "manufacturer": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteEquipment"
        },
        "containerPropertyIdentifier": "manufacturer",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The manufacturer of the equipment.",
        "name": "Manufacturer"
      },
      "equipmentType": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteEquipmentType"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteEquipmentType",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteEquipment"
        },
        "containerPropertyIdentifier": "equipmentType",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Specifies the type of the equipment. It's a direct relation to CogniteEquipmentType.",
        "name": "Equipment type"
      },
      "files": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "list": true,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFile",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteEquipment"
        },
        "containerPropertyIdentifier": "files",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "A list of files the equipment relates to.",
        "name": "Files"
      },
      "activities": {
        "connectionType": "multi_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "CogniteActivity",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteActivity",
            "version": "v1"
          },
          "identifier": "equipment"
        },
        "targetsList": true,
        "name": "Activities",
        "description": "An automatically updated list of activities related to the equipment."
      },
      "timeSeries": {
        "connectionType": "multi_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "CogniteTimeSeries",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteTimeSeries",
            "version": "v1"
          },
          "identifier": "equipment"
        },
        "targetsList": true,
        "name": "Time series",
        "description": "An automatically updated list of time series related to the equipment."
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteEquipment"
      }
    ],
    "name": "Equipment",
    "description": "Equipment represents physical supplies or devices.",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteEquipmentType",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1726823088691,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "code": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteEquipmentType"
        },
        "containerPropertyIdentifier": "code",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "A unique identifier for the type of equipment.",
        "name": "Code"
      },
      "equipmentClass": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteEquipmentType"
        },
        "containerPropertyIdentifier": "equipmentClass",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Represents the class of equipment.",
        "name": "Equipment class"
      },
      "standard": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteEquipmentType"
        },
        "containerPropertyIdentifier": "standard",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "An identifier for the standard this equipment type is sourced from, for example, ISO14224.",
        "name": "Standard"
      },
      "standardReference": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteEquipmentType"
        },
        "containerPropertyIdentifier": "standardReference",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "A reference to the source of the equipment standard.",
        "name": "Standard reference"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteEquipmentType"
      }
    ],
    "name": "Equipment type",
    "description": "Represents the type of equipment.",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteFile",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1726823088691,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "sourceId": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceId",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Identifier from the source system"
      },
      "sourceContext": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceContext",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set."
      },
      "source": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "source",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a source system"
      },
      "sourceCreatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was created in source system (if available)"
      },
      "sourceUpdatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was last updated in the source system (if available)"
      },
      "sourceCreatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "sourceUpdatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "assets": {
        "constraintState": {
          "maxListSize": "current"
        },
        "type": {
          "type": "direct",
          "list": true,
          "maxListSize": 1200,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteAsset",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteFile"
        },
        "containerPropertyIdentifier": "assets",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "A list of assets this file is related to.",
        "name": "Assets"
      },
      "mimeType": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteFile"
        },
        "containerPropertyIdentifier": "mimeType",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The MIME type of the file.",
        "name": "MIME type"
      },
      "directory": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteFile"
        },
        "containerPropertyIdentifier": "directory",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Contains the path elements from the source (if the source system has a file system hierarchy or similar.)",
        "name": "Directory"
      },
      "isUploaded": {
        "constraintState": {},
        "type": {
          "type": "boolean",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteFile"
        },
        "containerPropertyIdentifier": "isUploaded",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "defaultValue": false,
        "description": "Specifies if the file content has been uploaded to Cognite Data Fusion or not.",
        "name": "Is uploaded"
      },
      "uploadedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteFile"
        },
        "containerPropertyIdentifier": "uploadedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The time the file upload completed.",
        "name": "Uploaded time"
      },
      "category": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteFileCategory",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteFile"
        },
        "containerPropertyIdentifier": "category",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Specifies the detected category the file belongs to. It's a direct relation to an instance of CogniteFileCategory.",
        "name": "Category"
      },
      "equipment": {
        "connectionType": "multi_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "CogniteEquipment",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteEquipment",
            "version": "v1"
          },
          "identifier": "files"
        },
        "targetsList": true,
        "name": "Equipment",
        "description": "An automatically updated list of equipment this file is related to."
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteFile"
      }
    ],
    "name": "File",
    "description": "Represents files.",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteFileCategory",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1726823088691,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "code": {
        "constraintState": {
          "nullability": "current"
        },
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteFileCategory"
        },
        "containerPropertyIdentifier": "code",
        "immutable": false,
        "nullable": false,
        "autoIncrement": false,
        "description": "An identifier for the category, for example, 'AA' for Accounting (from Norsok.)",
        "name": "Code"
      },
      "standard": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteFileCategory"
        },
        "containerPropertyIdentifier": "standard",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The name of the standard the category originates from, for example, 'Norsok'.",
        "name": "Standard"
      },
      "standardReference": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteFileCategory"
        },
        "containerPropertyIdentifier": "standardReference",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "A reference to the source of the category standard.",
        "name": "Standard reference"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteFileCategory"
      }
    ],
    "name": "File category",
    "description": "Represents the categories of files as determined by contextualization or categorization.",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteActivity",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1726823088691,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "sourceId": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceId",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Identifier from the source system"
      },
      "sourceContext": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceContext",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set."
      },
      "source": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "source",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a source system"
      },
      "sourceCreatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was created in source system (if available)"
      },
      "sourceUpdatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was last updated in the source system (if available)"
      },
      "sourceCreatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "sourceUpdatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "startTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSchedulable"
        },
        "containerPropertyIdentifier": "startTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The actual start time of an activity (or similar that extends this)"
      },
      "endTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSchedulable"
        },
        "containerPropertyIdentifier": "endTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The actual end time of an activity (or similar that extends this)"
      },
      "scheduledStartTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSchedulable"
        },
        "containerPropertyIdentifier": "scheduledStartTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The planned start time of an activity (or similar that extends this)"
      },
      "scheduledEndTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSchedulable"
        },
        "containerPropertyIdentifier": "scheduledEndTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The planned end time of an activity (or similar that extends this)"
      },
      "assets": {
        "constraintState": {
          "maxListSize": "current"
        },
        "type": {
          "type": "direct",
          "list": true,
          "maxListSize": 1200,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteAsset",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteActivity"
        },
        "containerPropertyIdentifier": "assets",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "A list of assets the activity is related to.",
        "name": "Assets"
      },
      "equipment": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "list": true,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteEquipment",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteActivity"
        },
        "containerPropertyIdentifier": "equipment",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "A list of equipment the activity is related to.",
        "name": "Equipment"
      },
      "timeSeries": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "list": true,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteTimeSeries",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteActivity"
        },
        "containerPropertyIdentifier": "timeSeries",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "A list of time series the activity is related to.",
        "name": "Time series"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteSchedulable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteActivity"
      }
    ],
    "name": "Activity",
    "description": "Represents activities. Activities typically happen over a period and have a start and end time.",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteSchedulable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteTimeSeries",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1762948883038,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "sourceId": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceId",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Identifier from the source system"
      },
      "sourceContext": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceContext",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set."
      },
      "source": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "source",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a source system"
      },
      "sourceCreatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was created in source system (if available)"
      },
      "sourceUpdatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was last updated in the source system (if available)"
      },
      "sourceCreatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "sourceUpdatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "isStep": {
        "constraintState": {
          "nullability": "current"
        },
        "type": {
          "type": "boolean",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteTimeSeries"
        },
        "containerPropertyIdentifier": "isStep",
        "immutable": false,
        "nullable": false,
        "autoIncrement": false,
        "defaultValue": false,
        "description": "Specifies whether the time series is a step time series or not.",
        "name": "Is step"
      },
      "type": {
        "constraintState": {
          "nullability": "current"
        },
        "type": {
          "type": "enum",
          "values": {
            "string": {
              "name": "string",
              "description": "Time series with string data points."
            },
            "numeric": {
              "name": "numeric",
              "description": "Time series with double floating point data points."
            },
            "state": {
              "name": "state",
              "description": "Time series with state data points."
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteTimeSeries"
        },
        "containerPropertyIdentifier": "type",
        "immutable": true,
        "nullable": false,
        "autoIncrement": false,
        "description": "Specifies the data type of the data points.",
        "name": "Type"
      },
      "sourceUnit": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteTimeSeries"
        },
        "containerPropertyIdentifier": "sourceUnit",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The unit specified in the source system.",
        "name": "Source unit"
      },
      "unit": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteUnit"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteUnit",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteTimeSeries"
        },
        "containerPropertyIdentifier": "unit",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The unit of the time series.",
        "name": "Unit"
      },
      "assets": {
        "constraintState": {
          "maxListSize": "current"
        },
        "type": {
          "type": "direct",
          "list": true,
          "maxListSize": 1200,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteAsset",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteTimeSeries"
        },
        "containerPropertyIdentifier": "assets",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "A list of assets the time series is related to.",
        "name": "Assets"
      },
      "equipment": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "list": true,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteEquipment",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteTimeSeries"
        },
        "containerPropertyIdentifier": "equipment",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "A list of equipment the time series is related to.",
        "name": "Equipment"
      },
      "stateSet": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteStateSet"
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteTimeSeries"
        },
        "containerPropertyIdentifier": "stateSet",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The state set of the time series. It is only in effect when the type is 'state'.",
        "name": "State set"
      },
      "activities": {
        "connectionType": "multi_reverse_direct_relation",
        "source": {
          "type": "view",
          "space": "cdf_cdm",
          "externalId": "CogniteActivity",
          "version": "v1"
        },
        "through": {
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteActivity",
            "version": "v1"
          },
          "identifier": "timeSeries"
        },
        "targetsList": true,
        "name": "Activities",
        "description": "An automatically updated list of activities the time series is related to."
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteTimeSeries"
      }
    ],
    "name": "Time series",
    "description": "Represents a series of data points in time order.",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteAnnotation",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "edge",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "sourceId": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceId",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Identifier from the source system"
      },
      "sourceContext": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceContext",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set."
      },
      "source": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "source",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a source system"
      },
      "sourceCreatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was created in source system (if available)"
      },
      "sourceUpdatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was last updated in the source system (if available)"
      },
      "sourceCreatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "sourceUpdatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "confidence": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAnnotation"
        },
        "containerPropertyIdentifier": "confidence",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The confidence that the annotation is a good match"
      },
      "status": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "Suggested": {
              "name": "Suggested"
            },
            "Approved": {
              "name": "Approved"
            },
            "Rejected": {
              "name": "Rejected"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAnnotation"
        },
        "containerPropertyIdentifier": "status",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The status of the annotation"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteAnnotation"
      }
    ],
    "description": "Annotation represents contextualization results or links",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteDiagramAnnotation",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "edge",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "sourceId": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceId",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Identifier from the source system"
      },
      "sourceContext": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceContext",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set."
      },
      "source": {
        "constraintState": {},
        "type": {
          "type": "direct",
          "container": {
            "type": "container",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem"
          },
          "list": false,
          "source": {
            "type": "view",
            "space": "cdf_cdm",
            "externalId": "CogniteSourceSystem",
            "version": "v1"
          }
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "source",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Direct relation to a source system"
      },
      "sourceCreatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was created in source system (if available)"
      },
      "sourceUpdatedTime": {
        "constraintState": {},
        "type": {
          "type": "timestamp",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedTime",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "When the instance was last updated in the source system (if available)"
      },
      "sourceCreatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceCreatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "sourceUpdatedUser": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteSourceable"
        },
        "containerPropertyIdentifier": "sourceUpdatedUser",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF"
      },
      "confidence": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAnnotation"
        },
        "containerPropertyIdentifier": "confidence",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The confidence that the annotation is a good match"
      },
      "status": {
        "constraintState": {},
        "type": {
          "type": "enum",
          "values": {
            "Suggested": {
              "name": "Suggested"
            },
            "Approved": {
              "name": "Approved"
            },
            "Rejected": {
              "name": "Rejected"
            }
          },
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteAnnotation"
        },
        "containerPropertyIdentifier": "status",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The status of the annotation"
      },
      "startNodePageNumber": {
        "constraintState": {},
        "type": {
          "type": "int64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDiagramAnnotation"
        },
        "containerPropertyIdentifier": "startNodePageNumber",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The number of the page on which this annotation is located in `startNode` File. The first page has number 1\n"
      },
      "endNodePageNumber": {
        "constraintState": {},
        "type": {
          "type": "int64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDiagramAnnotation"
        },
        "containerPropertyIdentifier": "endNodePageNumber",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The number of the page on which this annotation is located in the endNode File if an endNode is present. The first page has number 1\n"
      },
      "startNodeXMin": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDiagramAnnotation"
        },
        "containerPropertyIdentifier": "startNodeXMin",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Value between [0,1]. Minimum abscissa of the bounding box (left edge). Must be strictly less than startNodeXMax\n"
      },
      "startNodeXMax": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDiagramAnnotation"
        },
        "containerPropertyIdentifier": "startNodeXMax",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Value between [0,1]. Maximum abscissa of the bounding box (right edge). Must be strictly more than startNodeXMin\n"
      },
      "startNodeYMin": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDiagramAnnotation"
        },
        "containerPropertyIdentifier": "startNodeYMin",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Value between [0,1]. Minimum ordinate of the bounding box (bottom edge). Must be strictly less than startNodeYMax\n"
      },
      "startNodeYMax": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDiagramAnnotation"
        },
        "containerPropertyIdentifier": "startNodeYMax",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Value between [0,1]. Maximum ordinate of the bounding box (top edge). Must be strictly more than startNodeYMin\n"
      },
      "startNodeText": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDiagramAnnotation"
        },
        "containerPropertyIdentifier": "startNodeText",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The text extracted from within the bounding box on the startNode"
      },
      "endNodeXMin": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDiagramAnnotation"
        },
        "containerPropertyIdentifier": "endNodeXMin",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Value between [0,1]. Minimum abscissa of the bounding box (left edge). Must be strictly less than endNodeXMax. Only applicable if an endNode is defined\n"
      },
      "endNodeXMax": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDiagramAnnotation"
        },
        "containerPropertyIdentifier": "endNodeXMax",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Value between [0,1]. Maximum abscissa of the bounding box (right edge). Must be strictly more than endNodeXMin. Only applicable if an endNode is defined\n"
      },
      "endNodeYMin": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDiagramAnnotation"
        },
        "containerPropertyIdentifier": "endNodeYMin",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Value between [0,1]. Minimum ordinate of the bounding box (bottom edge). Must be strictly less than endNodeYMax. Only applicable if an endNode is defined\n"
      },
      "endNodeYMax": {
        "constraintState": {},
        "type": {
          "type": "float64",
          "list": false
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDiagramAnnotation"
        },
        "containerPropertyIdentifier": "endNodeYMax",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Value between [0,1]. Maximum ordinate of the bounding box (top edge). Must be strictly more than endNodeYMin. Only applicable if an endNode is defined\n"
      },
      "endNodeText": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDiagramAnnotation"
        },
        "containerPropertyIdentifier": "endNodeText",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The text extracted from within the bounding box on the endNode. Only applicable if an endNode is defined\n"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteAnnotation"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDiagramAnnotation"
      }
    ],
    "description": "Annotation for diagrams",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteSourceable",
        "version": "v1"
      },
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteAnnotation",
        "version": "v1"
      }
    ]
  },
  {
    "externalId": "CogniteUnit",
    "space": "cdf_cdm",
    "version": "v1",
    "createdTime": 1724939215847,
    "lastUpdatedTime": 1724939215847,
    "writable": true,
    "queryable": true,
    "usedFor": "node",
    "isGlobal": true,
    "properties": {
      "name": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "name",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Name of the instance"
      },
      "description": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "description",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Description of the instance"
      },
      "tags": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "tags",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Text based labels for generic use, limited to 1000"
      },
      "aliases": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": true,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteDescribable"
        },
        "containerPropertyIdentifier": "aliases",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Alternative names for the node"
      },
      "symbol": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteUnit"
        },
        "containerPropertyIdentifier": "symbol",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "The symbol for the unit of measurement"
      },
      "quantity": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteUnit"
        },
        "containerPropertyIdentifier": "quantity",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Specifies the physical quantity the unit measures"
      },
      "source": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteUnit"
        },
        "containerPropertyIdentifier": "source",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Source of the unit definition"
      },
      "sourceReference": {
        "constraintState": {},
        "type": {
          "type": "text",
          "list": false,
          "collation": "ucs_basic"
        },
        "container": {
          "type": "container",
          "space": "cdf_cdm",
          "externalId": "CogniteUnit"
        },
        "containerPropertyIdentifier": "sourceReference",
        "immutable": false,
        "nullable": true,
        "autoIncrement": false,
        "description": "Reference to the source of the unit definition"
      }
    },
    "mappedContainers": [
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable"
      },
      {
        "type": "container",
        "space": "cdf_cdm",
        "externalId": "CogniteUnit"
      }
    ],
    "description": "Represents a single unit of measurement",
    "implements": [
      {
        "type": "view",
        "space": "cdf_cdm",
        "externalId": "CogniteDescribable",
        "version": "v1"
      }
    ]
  }
];

export const VIEW_MAPPER_CACHE = ViewMapperCache.fromViews(VIEW_DUMPS);
